<template>

<form
  :id="id"
  :name="name"
  @submit="onSubmit"
  :action="action"
  :method="method"
  >

  <FormElement
    v-for="(item, index) in items"
    :key="`${id}-${index}`"
    :item="item"/>

</form>

</template>

<script>
import FormElement from './FormElement.vue'

export default {
  name: 'Form',
  props: {
    id: String,
    name: String,
    action: String,
    method: String,
    submit: Object,
    items: Array
  },
  components: {
    FormElement
  },
  methods: {
    onSubmit: function() {
      (function() {
        var fnames = new Array();
        var ftypes = new Array();
        fnames[0]='EMAIL';
        ftypes[0]='email';
        fnames[6]='NAME';
        ftypes[6]='text';
        fnames[1]='FNAME';
        ftypes[1]='text';
        fnames[2]='LNAME';
        ftypes[2]='text';
        fnames[3]='ADDRESS';
        ftypes[3]='address';
        fnames[4]='PHONE';
        ftypes[4]='phone';
        fnames[5]='BIRTHDAY';
        ftypes[5]='birthday';
        window.fnames = fnames;
        window.ftypes = ftypes;
      }())
      window.jQuery.noConflict(true)
    }
  },
  mounted: function() {
    window.onSubmit = this.onSubmit;
  }
}
</script>

<style lang="scss" scoped>
</style>
